import { type AxiosResponse } from 'axios'
import api from '../utils/api'

export const getAllTerms = async (params?: Record<string, any>): Promise<AxiosResponse> => {
  return await api.get('/api/terms/summary/', { params })
}
export default {
  getAllTerms
}
